<template>
    <section id="dashboard">
        <!-- {{ DashboardDayValues }} -->
        <!-- <hr /> -->
        <!-- {{ DashboardMonthValues }} -->

        <!-- Welcome Card -->
        <v-container class="fill-height">
            <v-row>
                <v-col cols="12">
                    <v-card class="shadow-5">
                        <v-img
                            :src="
                                require('@/assets/illustrations/bg_dashboard_card.svg')
                            "
                            cover
                            position="top"
                            class="align-center"
                            :max-height="welcomeCardHeight"
                        >
                            <v-card-title>
                                <v-container fill-height fluid>
                                    <v-row
                                        align="center"
                                        justify="space-between"
                                        dense
                                    >
                                        <v-col cols="12" md="9">
                                            <h2
                                                :class="[
                                                    isMobile ? 'h3' : 'h2',
                                                    isMobile && isDark
                                                        ? 'white--text'
                                                        : 'primary--text'
                                                ]"
                                                style="word-break: normal"
                                            >
                                                ¡Hola, {{ userData.name }}!
                                            </h2>
                                            <p
                                                style="word-break: normal; line-height: normal"
                                            >
                                                Bienvenido de vuelta a PBXBerry.
                                                Ten una buena jornada
                                                productiva.
                                            </p>
                                        </v-col>

                                        <v-col
                                            cols="3"
                                            class="d-none d-md-block"
                                        >
                                            <v-img
                                                contain
                                                max-width="90%"
                                                class="mx-auto"
                                                :src="
                                                    require('@/assets/illustrations/agent.svg')
                                                "
                                                alt="Chart illustration"
                                            ></v-img>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-title>
                        </v-img>
                    </v-card>
                </v-col>
            </v-row>

            <!-- <v-row>
        <v-col cols="12" md="5" lg="4">
          <v-card class="shadow-5 py-1" :loading="isLoadingConnect">
            <v-list-item three-line>
              <v-list-item-content>
                <div class="overline mb-2">Planta</div>
                <v-list-item-title class="headline mb-1">
                  <span
                    :class="connectValue == 0 ? 'red--text' : 'green--text'"
                  >
                    {{ connectValue == 0 ? "Desconectado" : "Conectado" }}
                  </span>
                </v-list-item-title>
                <v-list-item-subtitle
                  >Conéctate para realizar llamadas con tu
                  extensión.</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>

            <v-card-actions>
              <v-hover v-slot:default="{ hover }">
                <v-btn
                  rounded
                  :loading="isLoadingConnect"
                  :color="connectValue == 0 ? 'success' : 'error'"
                  :depressed="connectValue == 0"
                  :text="connectValue == 1"
                  class="px-8"
                  @click="connect"
                >
                  {{ connectValue == 0 ? "Conectar" : "Desconectar" }}
                </v-btn>
              </v-hover>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row> -->

            <!-- {{ userData }} -->
        </v-container>
    </section>
</template>

<script>
import axios from "axios";
// import { mapState } from "vuex";

export default {
    inject: ["theme"],

    data() {
        return {
            userData: {}
            // isLoadingConnect: false
        };
    },

    computed: {
        isMobile() {
            return this.$vuetify.breakpoint.mobile;
        },

        isDark() {
            return this.$vuetify.theme.dark;
        },

        welcomeCardHeight() {
            if (this.$vuetify.breakpoint.mobile) {
                return "200";
            } else {
                return "150";
            }
        }

        // ...mapState({
        //   connectValue: (state) => state.passport.user.connect
        // })
    },

    mounted() {
        this.userData = JSON.parse(localStorage.getItem("user"));
    },

    methods: {
        // async connect() {
        //   this.isLoadingConnect = true;
        //   const accessToken = localStorage.getItem("token");
        //   try {
        //     const res = await this.$store.dispatch(
        //       "passport/UPDATE_CONNECTION_AGENT"
        //     );
        //     if (res.status === 200) {
        //       for (const client of res.data) {
        //         switch (client.codigo) {
        //           case "Added":
        //             this.$store.commit("passport/UPDATE_CONNECTION_AGENT", 1);
        //             this.$snotify.success(
        //               `${client.message}`,
        //               `Cola ${client.queue}`
        //             );
        //             break;
        //           case "Command":
        //             this.$snotify.error(
        //               `Cola ${client.queue}: ${client.message}`,
        //               "¡Error!"
        //             );
        //             break;
        //           case "Removed":
        //             this.$store.commit("passport/UPDATE_CONNECTION_AGENT", 0);
        //             this.$snotify.success(
        //               `${client.message}`,
        //               `Cola ${client.queue}`
        //             );
        //             break;
        //         }
        //       }
        //     }
        //   } catch (error) {
        //     console.error(error);
        //     this.$snotify.error("Error al conectar a planta.", "Error 500");
        //   } finally {
        //     this.isLoadingConnect = false;
        //   }
        // }
    }
};
</script>
